import { createEffect } from 'effector';
import { createGate } from 'effector-react';
import { isEmpty } from 'lodash';
import { type Location, NavigateFunction, type NavigateOptions, type To } from 'react-router-dom';

export const LocationGate = createGate<Location>();

export const NavigateGate = createGate<{ navigate: NavigateFunction }>();

// NavigateGate.open.watch(() => {
//     console.log('NavigateGate opened');
// });

const navigateWithObject = (arg: { to: To; options?: NavigateOptions } | number): void => {
    if (isEmpty(NavigateGate.state.getState())) {
        console.warn(
            'You are trying to navigate, but NavigateGate is not opened.\nYou need to call navigate function after NavigateGate is mounted.',
        );
        return;
    }
    if (arg instanceof Object) {
        NavigateGate.state.map((state) => state.navigate).getState()(arg.to, arg.options);
    }
    if (typeof arg === 'number') {
        NavigateGate.state.map((state) => state.navigate).getState()(arg);
    }
};

function navigate(to: To, options?: NavigateOptions): void;
function navigate(delta: number): void;
function navigate(to: To | number | string, options?: NavigateOptions): void {
    if (to instanceof Object || typeof to === 'string') {
        navigateWithObject({ to, options });
    }
    if (typeof to === 'number') {
        navigateWithObject(to);
    }
}

export const navigateFx = createEffect((to: string | number) => {
    if (typeof to === 'number') {
        navigateWithObject(to);
    }
    if (typeof to === 'string') {
        navigateWithObject({ to });
    }
});

export default navigate;

// declare global {
//     interface Window {
//         navigate: typeof navigate;
//     }
// }

// window.navigate = navigate;
